import { Accordion, Stack } from "react-bootstrap";

import { ApplicationHelpType } from "../../../utilities/Constants";
import { Help } from "../../shared/Help";
import { ToggleIcon } from "../../../shared/ToggleIcon";

interface IAssessmentAccordionWrapperProps {
    accordionKey: string;
    children: React.ReactNode;
    disableToggle?: boolean;
    helpText?: string;
    helpTitle?: string;
    helpSubTitle?: string;
    isOpen: boolean;
    onSelectChange?: (idx: string) => void;
    secondaryTitle?: string;
    suppressBottomBorder?: boolean;
    title: string;
}

export function AssessmentAccordionItemWrapper(props: IAssessmentAccordionWrapperProps) {
    const handleToggleIconClick = () => {
        if (props.onSelectChange) props.onSelectChange(props.accordionKey.toString());
    };

    return (
        <Accordion.Item
            eventKey={props.accordionKey}
            style={{ borderBottom: !props.suppressBottomBorder ? '1px solid #c7c7c7' : '' }}
        >
            <>
                <Accordion.Header as="h5">
                    <Stack direction="horizontal" gap={1} style={{ alignItems: 'center' }}>
                        <span className="">
                            <ToggleIcon
                                isOpen={props.isOpen}
                                onClick={handleToggleIconClick}
                                disabled={props.disableToggle}
                            />
                        </span>
                        <h5
                            onClick={() => {
                                if (props.onSelectChange && !props.disableToggle)
                                    props.onSelectChange(props.accordionKey.toString());
                            }}
                            style={{ opacity: props.disableToggle ? 0.5 : 1 }}
                        >
                            {props.title}
                        </h5>
                        {props.helpText && (
                            <Help
                                helpText={props.helpText}
                                type={ApplicationHelpType.Info}
                                title={props.helpTitle ?? 'Help'}
                                subTitle={props.helpSubTitle}
                                additionalStyleClassNames="color-gray"
                            />
                        )}
                        {props.secondaryTitle && <span>{props.secondaryTitle}</span>}
                    </Stack>
                </Accordion.Header>
                <Accordion.Body>{props.children}</Accordion.Body>
            </>
        </Accordion.Item>
    );
}
